module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Db-Fc-Hc-Ia.28ecb429.png";